import BuildVideos from './components/buildVideos';
import Nav from './components/nav';
import Billboard from './components/billboard';
import Hero from './components/hero';
import VideoPlane from './components/videoPlane';
import VideoPlay from './components/videoPlay';
import HeadingsAnimation from './components/headings';
import Modal from './components/modal';
import ContactForm from './components/contactForm';

/* eslint-disable no-new */
// hero Animation
new Hero();

// modals
new Modal();

window.addEventListener('load', () => {
	const loadAssets = () => {
		const assets = document.querySelectorAll('[data-src]');
		assets.forEach(asset => {
			asset.src = asset.dataset.src;
		});
	};
	loadAssets();

	// headings animation
	new HeadingsAnimation();

	// contact form
	new ContactForm();
	// billboards
	const billBoards = [...document.querySelectorAll('[data-billboard]')];
	const createBillboards = () => billBoards.map(element => new Billboard({ element }));
	const billboardComponents = createBillboards();
	// planes
	new VideoPlane();
	// WCYB videos
	new BuildVideos();
	// video player

	const videoElements = [...document.querySelectorAll('[data-youtube-video]')];

	const tag = document.createElement('script');
	tag.src = 'https://www.youtube.com/iframe_api';
	tag.setAttribute('defer', 'defer');
	const firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	window.onYouTubeIframeAPIReady = () => {
		videoElements.forEach(element => {
			new VideoPlay({ element });
		});
	};

	// nav
	new Nav();

	const update = () => {
		billboardComponents.forEach(component => component.update());
		requestAnimationFrame(update);
	};
	update();
});
